export enum AddressValidationActions {
    SET_SELECTED_ADDRESS = 'IP/AVC/SET_SELECTED_ADDRESS',
    SET_FORM = 'IP/AVC/SET_FORM',
    SET_ADDRESSES = 'IP/AVC/SET_ADDRESSES',
    SET_JARVIS_RESPONSE = 'IP/AVC/SET_JARVIS_RESPONSE',
    SET_JARVIS_ERROR = 'IP/AVC/SET_JARVIS_ERROR',
    CHECK_SEAMLESS = 'IP/AVC/CHECK_SEAMLESS',
    CHECK_ADDRESS = 'IP/AVC/CHECK_ADDRESS',
    DELETE_ADDRESS = 'IP/AVC/DELETE_ADDRESS',
    CHANGE_ADDRESS = 'IP/AVC/CHANGE_ADDRESS',
    SET_SEAMLESS = 'IP/AVC/SET_SEAMLESS',
}

export enum JarvisErrorCodes {
    paramMissing = 'ERROR_REQUEST_PARAM_MISSING',
    invalidAddress = 'ERROR_INVALID_ADDRESS',
    captcha = 'ERROR_CAPTCHA_ERROR',
    productJson = 'ERROR_ZP_JSON_NOT_REACHABLE',
    gimli = 'ERROR_GIMLI_NOT_REACHABLE'
}
